import { mapSlice } from './map.slice.ts';

export const { updateMapInfo } = mapSlice.actions;
